<template>
  <div class="rootApp">
    <!--    <nav>-->
    <!--      <router-link to="/">Home</router-link> |-->
    <!--      <router-link to="/about">About</router-link>-->
    <!--    </nav>-->
    <!-- <div :class="activeName == 'home' ? 'layout' : 'layout1'"> -->
    <Layout>
      <div
        :style="
          activeName == 'innovationvally' ? 'display:none' : 'display:block'
        "
      >
        <div v-if="activeName != 'blankView'">
          <div v-if="activeName == 'home'">
            <div
              id="navBar"
              :class="navBarFixed == true ? 'ivu-affix' : 'unFixed'"
            >
              <Header v-if="!isMobile">
                <!--                    <Header>-->
                <Menu
                  :active-name="activeName"
                  ref="mainMeun"
                  theme="light"
                  mode="horizontal"
                >
                  <div class="layout-logo">
                    <router-link to="/home">
                      <div class="logo"></div>
                    </router-link>
                  </div>
                  <div class="layout-nav">
                    <menu-item name="home" to="/home">看园区</menu-item>
                    <menu-item name="office" to="/office">找办公</menu-item>
                    <menu-item name="rentApartment" to="/rentApartment"
                      >租公寓</menu-item
                    >
                    <menu-item name="about" to="/about">我们是</menu-item>
                    <div class="hot-line">
                      <Row style="position: absolute; right: 0; top: -35px">
                        <Col span="10" style="text-align: right"
                          >招商热线：</Col
                        >
                        <Col
                          span="14"
                          style="
                            line-height: 1.2;
                            padding-top: 18px;
                            white-space: pre;
                            font-size: 18px;
                          "
                        >
                          <div class="hot-line1" lang="ch">021-3858 6888</div>
                          <!-- <div class="hot-line2" lang="ch">185 2109 4411</div> -->
                        </Col>
                      </Row>
                    </div>
                    <!-- <menu-item name="/login" to="/login" >Login</menu-item>-->
                    <!-- <menu-item name="/admin" to="/admin" >Admin</menu-item>-->
                  </div>
                </Menu>
              </Header>
            </div>
          </div>
          <Affix v-else :offset-top="0" style="z-index: 1000">
            <Header v-if="!isMobile">
              <Menu
                :active-name="activeName"
                ref="mainMeun"
                theme="light"
                mode="horizontal"
              >
                <div class="layout-logo">
                  <router-link to="/home" class="logo-link">
                    <div class="logo"></div>
                  </router-link>
                </div>
                <div class="layout-nav">
                  <menu-item name="home" to="/home">看园区</menu-item>
                  <menu-item name="office" to="/office">找办公</menu-item>
                  <menu-item name="rentApartment" to="/rentApartment"
                    >租公寓</menu-item
                  >
                  <menu-item name="about" to="/about">我们是</menu-item>
                  <div
                    class="hot-line"
                    v-if="
                      activeName === 'office' || activeName === 'officeDetail'
                    "
                  >
                    <Row
                      style="
                        position: absolute;
                        right: 0;
                        top: -35px;
                        color: #f90;
                      "
                    >
                      <Col span="10" style="text-align: right">招商热线：</Col>
                      <Col
                        span="14"
                        style="
                          line-height: 1.2;
                          padding-top: 18px;
                          white-space: pre;
                          font-size: 18px;
                        "
                      >
                        <div class="hot-line1" lang="ch">021-3858 6888</div>
                        <!-- <div class="hot-line2" lang="ch">185 2109 4411</div> -->
                      </Col>
                    </Row>
                  </div>
                  <!--<div class="tel-txt" v-if="activeName === 'office' || activeName === 'officeDetail'" >
                  <Row style="display: flex;flex-direction: row;justify-items: center;align-items: center">
                    <Col>招商热线：</Col>
                    <Col>021-3858 6888<br/>185 2109 4411</Col>

                  </Row>
                </div>-->
                  <!-- <menu-item name="/login" to="/login" >Login</menu-item>-->
                  <!-- <menu-item name="/admin" to="/admin" >Admin</menu-item>-->
                </div>
              </Menu>
            </Header>
          </Affix>
        </div>
      </div>
      <router-view />
      <div>
        <div v-if="activeName != 'blankView'">
          <Footer
            :style="
              activeName == 'innovationvally' ? 'display:none' : 'display:block'
            "
            v-if="!isMobile"
          />
          <NetMonitor v-if="!isMobile" />
        </div>

        <div v-if="isMobile" class="mobile-phone">
          <a href="tel:021-3858 6888"
            ><Icon
              size="24"
              style="padding-right: 10px"
              type="ios-call"
            />021-3858 6888</a
          >
        </div>
      </div>
    </Layout>

    <!-- </div> -->
  </div>
</template>

<script>
import Footer from "@/components/Footer.vue";
import NetMonitor from "@/components/NetMonitor";

export default {
  name: "App",
  components: {
    Footer,
    NetMonitor,
  },
  computed: {},
  data() {
    return {
      activeName: "home",
      navBarFixed: false,
      isMobile: false,
    };
  },
  created() {
    this.init();
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },

  methods: {
    handleScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > 300) {
        this.navBarFixed = true;
      } else {
        this.navBarFixed = false;
      }
    },
    init() {
      const ua = window.navigator.userAgent;
      // isMobile = false;// eslint-disable-line no-unused-vars
      if (ua.indexOf("iPhone") >= 0) this.isMobile = true;
      if (ua.indexOf("Android") >= 0) this.isMobile = true;
      if (ua.indexOf("iPad") >= 0) this.isMobile = true;
    },
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  watch: {
    $route: {
      deep: true,
      handler: function (newValue) {
        this.activeName = newValue.path.substring(1);
      },
    },
  },
};
</script>
<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.rootApp {
  position: relative;
  .ivu-layout {
    width: 100%;
    box-shadow: 0px 0px 1px 0px rgba(24, 36, 84, 0.5);
    box-sizing: border-box;

    .ivu-affix {
      /*box-shadow: 0px 0px 1px 0px rgba(24, 36, 84, 0.5);*/
      background-color: #fff;
      width: 100%;
      z-index: 200;
    }

    .ivu-layout-header {
      padding: 0;
      /*width: 1170px;*/
      /*margin: 0 auto;*/
      /*height: 60px;*/
      width: 100%;
      background: #fff;
      border-bottom: 1px solid #ddd;
      .ivu-menu {
        width: 1170px;
        margin: 0 auto;
        height: 60px;

        &.ivu-menu-horizontal {
          &.ivu-menu-light {
            &:after {
              display: none;
            }

            .ivu-menu-item {
              height: 40px;
              line-height: 40px;
              margin-top: 10px;
              margin-left: 15px;
              color: #333;
              &.ivu-menu-item-active,
              &.ivu-menu-item-selected {
                border-bottom: 2px solid #fff;
                color: #053291;
                border-radius: 18px 18px 5px 18px;
                box-shadow: 0px 0px 10px 0px rgba(151, 151, 151, 0.5);
              }

              &:hover {
                border-bottom: 2px solid #2d8cf0;
                border-radius: 18px 18px 5px 18px;
                box-shadow: 0px 0px 10px 0px rgba(151, 151, 151, 0.5);
              }
            }
          }
        }

        .layout-logo {
          float: left;
          display: flex;
          .logo-link {
            display: inline-block;
          }
          .logo {
            margin-top: 20px;
            display: block;
            width: 170px;
            height: 24px;
            background: url("../src/assets/images/web/logo-sd2.png") no-repeat;
          }
          .tel-txt {
            display: inline-block;
            line-height: 1.2;
            font-size: 20px;
            font-weight: bold;
            padding-left: 20px;
            padding-top: 8px;
            color: #1272a4;
            text-align: justify;
            text-align-last: justify;
          }
        }

        .layout-nav {
          float: right;
        }
      }
    }
    .unFixed {
      width: 100%;
      .ivu-layout-header {
        position: fixed;
        background: none;
        border: none;
        top: 0;
        z-index: 100;
        .ivu-menu {
          height: 60px;

          &.ivu-menu-horizontal {
            &.ivu-menu-light {
              background: none;
              &:after {
                display: none;
              }

              .ivu-menu-item {
                height: 40px;
                line-height: 40px;
                margin-top: 10px;
                color: #fff;

                &.ivu-menu-item-active,
                &.ivu-menu-item-selected {
                  border-bottom: 2px solid #fff;
                  color: #fff;
                  border-radius: 0;
                  box-shadow: none;
                }

                &:hover {
                  border-bottom: 2px solid #fff;
                  border-radius: 0;
                  box-shadow: none;
                }
              }
            }
          }

          .layout-logo {
            float: left;
            display: flex;
            .logo {
              margin-top: 20px;
              display: block;
              width: 170px;
              height: 24px;
              background: url("../src/assets/images/web/logo-white.png")
                no-repeat;
            }
          }

          .layout-nav {
            float: right;
          }
        }
      }
    }
    .hot-line {
      width: 200px;
      display: inline-block;
      color: #053291;
      position: relative;
      top: 0;
      font-weight: bold;
      .hot-line1 {
        width: 130px;
        text-align: justify;
      }
      .hot-line2 {
        width: 130px;
        text-align: justify;
        text-align-last: justify;
      }
    }
  }
  .mobile-phone {
    position: fixed;
    background: rgba(255, 255, 255, 0.5);
    padding: 10px 0;
    box-sizing: border-box;
    width: 100%;
    text-align: center;
    bottom: 0;
    left: 0;
    z-index: 1000;
    a {
      font-size: 20px;
      color: #fff;
      background: #f90;
      padding: 10px;
      width: 80%;
      margin-left: 10%;
      border-radius: 50px;
      display: block;
    }
  }
}
</style>
